export default __webpack_public_path__ + "static/dollar-1ef30ad5ce3b6c79fafac48558e42dad.png";